import { useAppbarTitle } from '@hooks/useAppbarTitle';

// import { DeactivateCard } from '@features/dashboard/specialistDashboard/specialistAccountSettings/DeactivateCard';
import { PasswordCard } from '@features/dashboard/specialistDashboard/specialistAccountSettings/PasswordCard';
// import { PaymentCard } from '@features/dashboard/specialistDashboard/specialistAccountSettings/PaymentCard';
import { usePageTitle } from '@hooks/usePageTitle';
// import { RoleEnum } from '@utils/util.types';
import { useTranslation } from 'react-i18next';
import { useUsersStore } from 'services/users';
import './styles.css';

export const AccountPage = () => {
	const { t } = useTranslation();

	useAppbarTitle('myProfile');
	usePageTitle(t('myProfile'));

	const { user } = useUsersStore();

	return (
		<div className="grid grid-cols-2 gap-5 max-md:grid-cols-1">
			{/* {user?.role?.toLowerCase() === RoleEnum.Specialist.toLowerCase() && <PaymentCard />} */}
			<PasswordCard />
			{/* <DeactivateCard /> */}
		</div>
	);
};
